import React from "react";
import "./aboutPage.css";
import Nav from "../../components/nav/Nav";
import AboutBg from "../../assets/aboutBg.png";
import HandShakeBg from "../../assets/handshake.png";

import Footer from "../../components/footer/Footer";
import Contact from "../../components/contact/Contact";
import FileClaim from "../../pages/home/components/FileClaim";
import { ReactComponent as Slide } from "../../assets/Component 5.svg";
import { ReactComponent as SlideBg } from "../../assets/Component 4.svg";
import { Grid, GridCol } from "@mantine/core";
import { ReactComponent as InstructIconOne } from "../../assets/instructIconOne.svg";
import { ReactComponent as InstructIconTwo } from "../../assets/instructIconTwo.svg";
import { ReactComponent as InstructIconThree } from "../../assets/instructIconThree.svg";
import { ReactComponent as BgOne } from "../../assets/instructOneBg.svg";
import { ReactComponent as BgTwo } from "../../assets/instructTwoBg.svg";
import { ReactComponent as BgThree } from "../../assets/instructThreeBg.svg";
import { ReactComponent as MobileBgOne } from "../../assets/MobileBGOne.svg";
import { ReactComponent as MobileBgTwo } from "../../assets/MobileBGTwo.svg";
import { ReactComponent as MobileBgThree } from "../../assets/MobileBGThree.svg";

const AboutPage = () => {
  return (
    <div className="about-container">
      <img src={AboutBg} className="bg-image" />

      <Nav />

      <div className="about-left-wrapper">
        <SlideBg className="slide-bg" />

        <div className="inner-about-continer">
          <h1 className="about-main-header">About Fly n’ Claim</h1>
          <p className="sub-header" style={{ width: "90%", marginTop: "30px" }}>
            At <strong>Fly n’ Claim</strong>, we specialize in helping travelers
            get the compensation they deserve when airlines disrupt their
            journey. Whether your flight was{" "}
            <strong>delayed, canceled, overbooked</strong>, or your{" "}
            <strong>baggage was lost or damaged</strong>, we’re here to fight
            for your rights and make the process simple and stress-free.
          </p>
          <p className="sub-header" style={{ width: "90%", marginTop: "20px" }}>
            We know how frustrating it can be to deal with airlines, paperwork,
            and complex regulations. That’s why we’ve made it our mission to
            simplify the claim process, so you can focus on what matters — your
            travels.
          </p>
        </div>
      </div>

      <div className="container-wrapper">
        <div className="claim-process-wrapper">
          <h5 className="sub-header-red">What we do</h5>
          <h3 className="header">Fly n’ Claim handles everything for you</h3>
          <p className="sub-header">
            With our No Win, No Fee policy, there’s zero risk to you. If we
            don’t win your case, you pay absolutely nothing.
          </p>
        </div>

        <div className="instruct-card-wrapper desktop-wrapper">
          <div className="instruct-card instruct-card-bg1">
            <BgOne
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />

            <InstructIconOne />
            <div className="text-wrapper">
              <p className="card-step-text">Step 1</p>
              <p className="cart-text">Submit your claim</p>
              <p className="cart-sub-text">
                Fill out our quick online form with the details of your flight.
              </p>
            </div>
          </div>

          <div className="instruct-card instruct-card-bg2">
            <BgTwo
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />

            <InstructIconTwo />
            <div className="text-wrapper">
              <p className="card-step-text">Step 2</p>
              <p className="cart-text">We take over</p>
              <p className="cart-sub-text">
                Our legal experts handle all communication and negotiation with
                the airline.
              </p>
            </div>
          </div>

          <div className="instruct-card instruct-card-bg3">
            <BgThree
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />

            <InstructIconThree />
            <div className="text-wrapper">
              <p className="card-step-text" style={{ color: "#222222" }}>
                Step 3
              </p>
              <p className="cart-text" style={{ color: "#314064" }}>
                Get compensated
              </p>
              <p className="cart-sub-text" style={{ color: "#565A6D" }}>
                Once your claim is approved, the compensation is transferred
                directly to you.
              </p>
            </div>
          </div>
        </div>

        {/* mobile  */}

        <div className="instruct-card-wrapper mobile-wrapper">
          <div className="instruct-card instruct-card-bg1">
            <MobileBgOne
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />
            <span className="mobile-instructon-icon-wrapper">
              <InstructIconOne />
            </span>
            <div className="text-wrapper">
              <p className="card-step-text">Step 1</p>
              <p className="cart-text">Submit your claim</p>
              <p className="cart-sub-text">
                Fill out our easy online form with details of your flight.
              </p>
            </div>
          </div>

          <div className="instruct-card instruct-card-bg2">
            <MobileBgTwo
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />

            <span className="mobile-instructon-icon-wrapper">
              <InstructIconTwo />
            </span>
            <div className="text-wrapper">
              <p className="card-step-text">Step 2</p>
              <p className="cart-text">We will handle the process</p>
              <p className="cart-sub-text">
                Our legal team negotiates directly with the airline
              </p>
            </div>
          </div>

          <div className="instruct-card instruct-card-bg3">
            <MobileBgThree
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: "-1",
              }}
            />

            <span className="mobile-instructon-icon-wrapper">
              <InstructIconThree />
            </span>
            <div className="text-wrapper">
              <p className="card-step-text" style={{ color: "#222222" }}>
                Step 3
              </p>
              <p className="cart-text" style={{ color: "#314064" }}>
                Get Paid
              </p>
              <p className="cart-sub-text" style={{ color: "#565A6D" }}>
                Compensation is transferred directly to you.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-wrapper desktop-wrapper">
        <Grid>
          <GridCol span={6}>
            <img style={{ width: "100%", height: "auto" }} src={HandShakeBg} />
          </GridCol>

          <GridCol span={6}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "30px",
              }}
            >
              <h5 className="sub-header-red">Why Trust Fly n’ Claim?</h5>
              <h3 className="header">
                Proven results, thousands of happy clients
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "25px",
                }}
              >
                <div className="proven-result">
                  <div>
                    <span>1</span>
                    <h4>Expertise you can trust</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "59px" }}>
                    Our team specializes in aviation laws and regulations like
                    EU261 and the Montreal Convention.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>2</span>
                    <h4>Fast and simple process</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "59px" }}>
                    File your claim in minutes — we’ll handle the rest.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>3</span>
                    <h4>Global coverage</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "59px" }}>
                    We work with airlines worldwide, regardless of where you
                    traveled.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>4</span>
                    <h4>Thousands of successful claims</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "59px" }}>
                    We've recovered millions in compensation for travelers just
                    like you.
                  </p>
                </div>
              </div>
            </div>
          </GridCol>
        </Grid>
      </div>

      <div className="container-wrapper mobile-wrapper">
        <Grid>
          <GridCol span={{ base: 12, lg: 6 }}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <h5 className="sub-header-red">Why Trust Fly n’ Claim?</h5>
              <h3 className="header">
                Proven results, thousands of happy clients
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div className="proven-result">
                  <div>
                    <span>1</span>
                    <h4>Experience you can rely on</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "50px" }}>
                    Our team specializes in aviation laws and compensation
                    regulations like EU261.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>2</span>
                    <h4>Fast and simple process</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "50px" }}>
                    File your claim in minutes, and we handle the rest.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>3</span>
                    <h4>Global reach</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "50px" }}>
                    We work with airlines worldwide, no matter where you
                    traveled.
                  </p>
                </div>

                <div className="proven-result">
                  <div>
                    <span>4</span>
                    <h4>Thousands of success stories</h4>
                  </div>
                  <p className="sub-header" style={{ paddingLeft: "50px" }}>
                    We’ve recovered millions in compensation for travelers like
                    you.
                  </p>
                </div>
              </div>
            </div>
          </GridCol>

          <GridCol span={{ base: 12, lg: 6 }}>
            <img style={{ width: "100%", height: "auto" }} src={HandShakeBg} />
          </GridCol>
        </Grid>
      </div>

      <div className="our-mission-wrapper">
        <Slide className="slide-one" />
        <Slide className="slide-two" />
        <h3 className="header" style={{ color: "#FAFDFF" }}>
          Our mission
        </h3>
        <p className="sub-header-text text-center our-mission-sub-text">
          Our mission is to make flight compensation claims{" "}
          <strong>simple, fair, and accessible</strong> for everyone. We believe
          passengers have rights — and those rights should be protected. When
          you work with Fly n’ Claim, you're partnering with a team that values{" "}
          <strong>honesty, professionalism, and results</strong>.
        </p>
      </div>
      <FileClaim />
      <Contact />
      <Footer />
    </div>
  );
};

export default AboutPage;
